export default __webpack_public_path__ + "static/media/logo.c36a93f0.svg";